import { Dashboard, DeveloperLicenses } from '@/components';

export const DeveloperLicensePage = (): JSX.Element => (
  <Dashboard>
    <DeveloperLicenses />
  </Dashboard>
);
